export default "https://cdn-shared.mathletics.com/teacher-modules/mx-portal/278/assets/images/close-c83d2d2e80909d0902f7cf58ad1d3691.svg";